/*                                                                                                                                                                                            */
import { defineRoute } from '@kestrel/router';

/*                                                                                     */
/*                                                         */
const isDevelopment = import.meta.env.VITE_ENVIRONMENT === 'develop';

export const routes = [
    defineRoute({
        path: '/health',
        methods: () => import('./views/health/+health.server.js'),
    }),
    defineRoute({
        path: '/internal/metrics',
        methods: () => import('./views/metrics/+metrics.server.js'),
    }),
    defineRoute({
        path: '/version',
        methods: () => import('./views/version/+version.server.js'),
    }),
    defineRoute({
        path: '/retailer/:variationId',
        template: () => import('./views/retailer/template.html?raw'),
        component: () => import('./views/retailer/+page.svelte'),
        server: () => import('./views/retailer/+page.server.js'),
    }),
    isDevelopment
        ? defineRoute({
              path: '/demo',
              template: () => import('./demo/template.html?raw'),
              component: () => import('./demo/conditionsPreview.svelte'),
              server: () => import('./demo/+page.server.js'),
          })
        : undefined,
].filter(Boolean);
